import Status from '@/creditflowresearch/ui/common/components/TableCells/DealStatus';
import Region from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Region';
import DateList from '@/creditflowresearch/ui/components/deals/DealListTable/cells/DateList';
import ProductAbbreviation from '@/creditflowresearch/ui/components/deals/DealListTable/cells/ProductAbbrevation';
import Issuers from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Issuers';
import Ticker from '@/creditflowresearch/ui/components/deals/DealListTable/cells/Ticker';
import UpsizedCell from '@/creditflowresearch/ui/common/components/TableCells/UpsizedCell';
import TotalSize from '@/creditflowresearch/ui/components/deals/DealListTable/cells/TotalSize';
import IndustryCell from '@/creditflowresearch/ui/common/components/TableCells/IndustryCell';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

export const columns = [
  {
    name: 'product',
    title: 'C/P',
    width: 60,
    cellCallback: ProductAbbreviation,
  },
  {
    name: 'industry',
    title: 'Industry',
    width: 70,
    className: alignStyles.alignCenter,
    cellCallback: ({ row: { primaryIssuer } }) => (
      <IndustryCell industry={ primaryIssuer?.industry } subindustry={ primaryIssuer?.subindustry } />
    ),
  },
  {
    name: 'status',
    title: 'Status',
    width: 80,
    className: alignStyles.alignCenter,
    cellCallback: ({ row }) => <Status status={ row.status } />,
  },
  {
    name: 'ticker',
    title: 'Ticker(s)',
    width: 200,
    maxWidth: 200,
    minWidth: 200,
    cellCallback: Ticker,
  },
  {
    name: 'additionalIssuers',
    title: 'Issuer(s)',
    className: alignStyles.alignLeft,
    cellCallback: Issuers,
  },
  {
    name: 'size',
    title: 'Size(m)',
    width: 100,
    className: alignStyles.alignRight,
    cellCallback: TotalSize,
  },
  {
    name: 'upsized',
    width: 12,
    maxWidth: 12,
    cellCallback: ({ row: { upsized } }) => <UpsizedCell upsized={ !!upsized } />,
  },
  {
    name: 'tranches',
    title: 'Tranches',
    className: alignStyles.alignRight,
    cellCallback: ({ row }) => row.tranches.length,
  },
  {
    name: 'region',
    title: 'Region',
    className: alignStyles.alignRight,
    width: 100,
    cellCallback: ({ row: { country } }) => <Region region={ country?.region } country={ country } />,
  },
  {
    name: 'expand',
    title: 'Date',
    className: alignStyles.alignRight,
    width: 150,
    cellCallback: DateList,
  },
];
